<template>
    <div v-if="!claveOlvidada">
        <h5 class="mb-4">Inicie sesión</h5>
        
        <Form role="form" class="text-start" :validation-schema="schema" @submit="handleInicioSesion">

            <soft-field
                id="usuario"
                v-model="user.usuario"
                type="text"
                placeholder="Email"
                name="usuario"
                class="mb-4"
            />

            <soft-field
                id="password"
                v-model="user.password"
                type="password"
                placeholder="Clave"
                name="password"
                class="mb-4"
            />

            <p class="mb-0" @click="enviarClave" style="font-style:italic;cursor:pointer;">Envíame la clave</p>

            <div class="mt-2">
                <QBtn type="submit" variant="tipster" label="Acceder" :loading="loading" :block="true" class="my-2 mb-2" />
            </div>
            <p class="login-legal-note text-muted">
              Al iniciar sesion confirmas que eres mayor de 18 años y aceptas el
              <router-link to="/aviso-legal">Aviso Legal</router-link>
              y la
              <router-link to="/politica-privacidad">Política de Privacidad</router-link>.
            </p>

        </Form>
    </div>

    <div v-if="claveOlvidada">
        <h5 class="mb-4">Recupere su clave:</h5>

        <Form role="form2" class="text-start" :validation-schema="schema2" @submit="handleClaveOlvidada">

            <soft-field
                id="usuario"
                v-model="emailOlvidado"
                type="text"
                placeholder="Email"
                name="emailOlvidado"
                class="mb-4"
                :readonly="esperandoCodigo!='A'"
            />

            <div v-if="esperandoCodigo=='B'"><!--  A la espera de que tecle el código -->
                <soft-field
                    id="codigo"
                    v-model="codigoOlvidado"
                    type="number"
                    placeholder="Código recibido"
                    name="codigoOlvidado"
                    class="mb-4" 
                />
            </div>

            <div v-if="esperandoCodigo=='C'"><!--  A la espera de que tecle el código -->
                <soft-field
                    id="newpassword1"
                    v-model="newPassword1"
                    type="password"
                    placeholder="Nueva clave"
                    name="newpassword1"
                    class="mb-4" 
                />

                <soft-field
                    id="newpassword2"
                    v-model="newPassword2"
                    type="password"
                    placeholder="Repita clave"
                    name="newpassword2"
                    class="mb-4" 
                />
            </div>

            <p class="mb-0" @click="()=>{claveOlvidada=false;esperandoCodigo='A';}" style="font-style:italic;cursor:pointer;">Ya recordé mi clave</p>

            <div class="mt-2">
                <QBtn type="submit" variant="tipster" label="Recuperar Clave" :loading="loading" :block="true" class="my-2 mb-2" />
            </div>
                        <p class="login-legal-note text-muted">
              Acceso reservado a mayores de 18 años. Más info en el
              <router-link to="/aviso-legal">Aviso Legal</router-link>.
            </p>

        </Form>
    </div>
  </template>
  
  <script>
  import SoftField from "@/components/SoftField.vue";
  import analytics from "@/services/analytics";
  import showSwal from "/src/mixins/showSwal.js";
  import { Form } from "vee-validate";
  import * as yup from "yup";

  export default {
    name: "InicioSesionForm",
    components: {
        SoftField,
        Form,
    },
    props: {
        esVisible: {
            type: Boolean,
            default: false
        },
        redireccionar: {
            type: Boolean,
            default: true
        },
    },
    data() {
        const schema = yup.object().shape({
            usuario: yup.string().required("Debe indicar su usuario!"),
            password: yup.string().required("Debe indicar su clave!"),
        });
        const schema2 = yup.object().shape({
            emailOlvidado: yup.string().required("Debe indicar su email!"),
        });
        const user = {
            usuario: "",
            password: "",
        };
        return {
            loading: false,
            claveOlvidada: false,
            esperandoCodigo: 'A',
            emailOlvidado: '',
            codigoOlvidado: '',
            newPassword1: '',
            newPassword2: '',
            user,
            schema,
            schema2
        };
    },
    watch: {
        esVisible(abriendo) { 
            if (abriendo) {
                this.loading = false,
                this.claveOlvidada = false,
                this.esperandoCodigo = 'A';
                this.emailOlvidado = '';
                this.codigoOlvidado = '';
                this.newPassword1 = '';
                this.newPassword2 = ''; 
                this.user = {
                    usuario: "",
                    password: "",
                };               
            }
        }
    },
    emits: ['cerrar-modal', 'login-exitoso'],
    methods: {
        enviarClave() {
            this.claveOlvidada = true;
            this.esperandoCodigo = 'A';
        },

      async handleInicioSesion() {
        // Aquí puedes realizar acciones cuando se envía el formulario
        //console.log('Formulario enviado:', this.user);
        this.loading = true;
        try {
            await this.$store.dispatch("auth/login", this.user);
            analytics.login();

            // Obtengo el nombre del perfil para mostrar en cabecera
            await this.$store.dispatch("profile/getProfile");
            const resp = this.$store.getters["profile/profile"];
            if (resp) {
              localStorage.setItem("usuarioNombre", resp.name);
              localStorage.setItem("usuarioEmail", resp.email);
              localStorage.setItem("usuarioRolId", resp.rol_id);
              localStorage.setItem("usuarioTipsterId", resp.tipster_id);
            }

           const rol = Number(resp?.rol_id || 0);
           if (this.redireccionar) {
                if (rol === 3) this.$router.push({ name: "PanelCliente" });
                else if (rol === 5) this.$router.push({ name: "PanelPublicista" });
                else if (rol === 4) this.$router.push({ name: "PanelTipster" });
                else this.$router.push({ name: "Dashboard" });
           } else {
                this.$emit('login-exitoso', resp.email || '');
           }
           

            
        } catch (error) {
            if (error.response) {
                showSwal.methods.showSwal({
                    type: "error",
                    message: "Datos de acceso erróneos",
                });
            }
            this.loading = false;
        }
      },
      async handleClaveOlvidada() {
        this.loading = true;
        try {
            if (this.esperandoCodigo=='A') {    // Se le envía un código de acceso
                this.loading = false;
                const resp = await this.$store.dispatch("auth/claveOlvidada", { email: this.emailOlvidado } );
                if (resp.res=='OK') {
                    showSwal.methods.showSwal({
                        type: "success",
                        message: resp.mensaje,
                        width: 400,
                    });
                    this.esperandoCodigo = 'B';
                }
            }
            else if (this.esperandoCodigo=='B') {      // Se introduce el código de acceso y se valida
                this.loading = false;
                const resp = await this.$store.dispatch("auth/codigoRecuperado", { email: this.emailOlvidado, codigo: this.codigoOlvidado } );
                if (resp.res=='OK') {
                    this.esperandoCodigo = 'C';
                }
                else {
                    showSwal.methods.showSwal({
                        type: "error",
                        message: resp.mensaje,
                        width: 400,
                    });
                }
            }
            else if (this.esperandoCodigo=='C') {      // Se guarda la nueva clave
                if (this.newPassword1!=this.newPassword2) {
                    this.loading = false;
                    showSwal.methods.showSwal({
                        type: "error",
                        message: "Las claves indicadas deben coincidir",
                        width: 400,
                    });
                }
                else {
                    const resp = await this.$store.dispatch("auth/establecerClave", { email: this.emailOlvidado, codigo: this.codigoOlvidado, clave: this.newPassword1 } );
                    this.loading = false;
                    if (resp.res=='OK') {
                        showSwal.methods.showSwal({
                            type: "success",
                            message: resp.mensaje,
                            width: 400,
                        });
                        this.esperandoCodigo = 'A';
                        this.user = {
                            usuario: this.emailOlvidado,
                            password: this.newPassword1,
                        };
                        this.handleInicioSesion();
                    } else {
                        showSwal.methods.showSwal({
                            type: "error",
                            message: resp.mensaje || "Error al cambiar la contraseña",
                            width: 400,
                        });
                    }
                }
            }
        } catch (error) {
            console.error("❌ Error en handleClaveOlvidada:", error);
            showSwal.methods.showSwal({
                type: "error",
                message: "Se ha producido un error",
            });
            this.loading = false;
        }
      }
    },
  };
  </script>
  
  <style scoped>
  /* Estilos específicos del componente MyForm */
  .boton {

  }
  .login-legal-note{
  font-size: 0.75rem;
  line-height: 1.1rem;
  text-align: center;
  margin-top: 10px;
  margin-bottom: 0;
  opacity: .85;
}

.login-legal-note a{
  font-weight: 700;
  text-decoration: underline;
}

  </style>